import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-do-consumidor.css'

const DireitoDoConsumidor = (props) => {
  return (
    <div className="direito-do-consumidor-container10">
      <Helmet>
        <title>
          Direito-do-Consumidor - Adv. Wanderson H Cavalari - Cuiabá
        </title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-do-Consumidor - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-do-consumidor-container11">
        <main className="direito-do-consumidor-container12">
          <div className="direito-do-consumidor-container13">
            <Header rootClassName="headerroot-class-name11"></Header>
            <div className="direito-do-consumidor-container14">
              <div className="direito-do-consumidor-frame46">
                <span className="direito-do-consumidor-text10">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-do-consumidor-text11">Direito do</span>
                <span className="direito-do-consumidor-text12">Consumidor</span>
                <span className="direito-do-consumidor-text13">
                  A advocacia na área do consumidor foca na proteção dos
                  direitos dos consumidores, garantindo que sejam tratados de
                  forma justa por empresas e fornecedores. Envolve desde
                  disputas individuais até ações coletivas, abrangendo questões
                  como defeitos de produtos, práticas comerciais enganosas e
                  violações de contratos de consumo.
                </span>
              </div>
              <div className="direito-do-consumidor-container15">
                <span className="direito-do-consumidor-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-do-consumidor-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-do-consumidor-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-do-consumidor-container16">
            <div className="direito-do-consumidor-container17">
              <div className="direito-do-consumidor-frame86">
                <div className="direito-do-consumidor-container18">
                  <div className="direito-do-consumidor-container19">
                    <span className="direito-do-consumidor-text17">
                      Nome negativado.
                    </span>
                    <span className="direito-do-consumidor-text18">
                      <span>
                        Quando uma pessoa tem seu nome negativado indevidamente,
                        ou seja, quando uma dívida é registrada em seu nome sem
                        justificativa legal, ela tem direito a tomar várias
                        medidas legais para corrigir essa situação. Aqui estão
                        as etapas comuns que podem ser seguidas no direito
                        brasileiro:
                      </span>
                      <br></br>
                      <span>
                        É importante ressaltar que o consumidor tem o direito de
                        ter seu nome protegido de negativações indevidas, e as
                        empresas que realizam registros falsos estão sujeitas a
                        sanções legais. Por isso, é fundamental que o consumidor
                        esteja ciente de seus direitos e esteja disposto a
                        buscar as medidas legais disponíveis para corrigir uma
                        negativação indevida.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/nome%20negativado%20heading-300h.webp"
                    loading="eager"
                    className="direito-do-consumidor-image section_image"
                  />
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name5"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoDoConsumidor
